// Developer bypass identifiers - allows these users to access dashboard
// export const allowedDevUsers: string[] = [];
export const allowedDevUsers = ["909-prashant.gurung@ramboll.co.uk", "2-prashant.gurung@ramboll.co.uk"];
